import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import ActionAdd from '../../store/action/FlowTemplate/Add'
import ActionEdit from '../../store/action/DivisionSetting/Edit'
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from '../../store/action/Division/FetchAll';
import ActionGetAllSender from '../../store/action/Sender/FetchAll';
import ActionGetDetailFlow from '../../store/action/FlowTemplate/GetDetailFlow'
class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            flowId: '',
            flowName: '',
            client_id: '',
            client_name: '',
            division_id: '',
            division_name: '',
            sender_id: '',
            sender_name: '',
            namespace: '',
            status: '',
            screen: [],
            category: '',
        };
        this.handleCancel = this.handleCancel.bind(this);
        this.getDetailFlow = this.getDetailFlow.bind(this);
    }

    componentDidMount() {
        console.log(this.props.item.get('client_id'),'item');
        var clients = this.props.clientall;
        var dataClient = clients.find(item => item.get('client-id') === this.props.item.get('client_id'));
        const clientId = this.props.item.get("client_id");
        console.log('Fetching divisions for client ID:', clientId);
        // Panggil aksi dan log hasilnya
        this.props.actionGetAllDivision(clientId)
        .then(() => {
            var divisions = this.props.divisionall;
            var dataDivision = divisions.find(item => item.get('division-id') === this.props.item.get('division_id'));
            this.setState({
                division_name: dataDivision.get('division-name'),
            })
        });
        this.props.actionGetAllSender(clientId, this.props.item.get('division_id'))
        .then(() => {
            var senders = this.props.senderall;
            var dataSender = senders.find(item => item.get('sender-id') === this.props.item.get('sender'));
            this.setState({
                sender_name: dataSender.get('sender-name'),
            })
        });
        var flowId = this.props.item.get('flow_id');
        this.setState({
            flowId: flowId,
            client_name: dataClient.get('client-name')
        })
        this.getDetailFlow(flowId);
    }

    async getDetailFlow(flowId) {
        var data = await this.props.actionGetDetailFlow(flowId);
        if (data) {
            var screens = [];
            data.get('screens').map((item) => {
                screens.push(item);
            })
            
            this.setState({
                flowName: data.get('flow_name'),
                client_id: data.get('client_id'),
                division_id: data.get('division_id'),
                sender_id: data.get('sender'),
                namespace: data.get('namespace'),
                status: data.get('status'),
                screen: screens,
                category: data.get('categories'),
            })
        }
    }

    handleCancel() {
        this.props.handleCancelForm(false);
    }

    render() {
        return (
            <div className="card no-margin-bottom">
                <div className="header">
                    <h4>Detail Flow</h4>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Flow Id : {this.state.flowId}</label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Flow Name : {this.state.flowName}</label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Client : {this.state.client_name}</label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Division : {this.state.division_name}</label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Sender : {this.state.sender_name}</label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Name Space : {this.state.namespace}</label>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Category : {this.state.category}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="body">
                    <div className="row">
                        {this.state.screen.map((item, i) => {
                            return (
                                <div key={i} className="col-sm-6">
                                    <div className="form-group">
                                        <label>Screen {i + 1} : {item}</label>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="row no-margin-bottom">
                        <div className="col-sm-10">
                            <button type="button"
                                className="btn btn-wide btn-danger"
                                value="Cancel"
                                onClick={this.handleCancel}>
                                Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
        }
    },
    dispatch => bindActionCreators({
        actionAdd: ActionAdd,
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionEdit: ActionEdit,
        actionGetDetailFlow: ActionGetDetailFlow,
    }, dispatch),
)(Form);